import * as yup from 'yup';

const packageSchema = yup.object().shape({
  name: yup.string().required('common.required'),
  isActive: yup.bool(),
  campId: yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  }).nullable().required('common.required'),
  accommodationIds: yup.array().of(yup.object().shape({
    value: yup.string(),
    label: yup.string(),
  })),
  isAccommodationMandatory: yup.bool(),
});

export default packageSchema;
